var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ReducedebtHeader',{attrs:{"img_header":_vm.header_image,"header":"ดูรายละเอียดสินค้า","link_back":"stock/storage/reducedebt"}}),_c('Reduce_debt_details')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }